import React from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter, Switch } from 'react-router-dom';
import { Box, makeStyles } from 'housecall-ui';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import CssBaseline from 'housecall-ui/dist/utils/CssBaseline';

import { AnonymousExperimentProvider } from '../../src/resources/amplitude/AnonymusProvider';
import { QueryClientProvider } from '../../src/resources/QueryClientProvider';
import { FormSkeleton } from '../components/FormSkeleton';

type Props = {
  children: React.ReactNode;
};

const MAX_WIDTH = 534;

const useStyles = makeStyles(() => ({
  container: {
    maxWidth: MAX_WIDTH,
  },
}));

export const LeadFormProviders = ({ children }: Props) => {
  const { container } = useStyles();
  return (
    <>
      <Helmet>
        <title>Lead form</title>
        <style>{`
          body {
            overflow: hidden;
          }
        `}</style>
      </Helmet>
      <CssBaseline />
      <HousecallThemeProvider>
        <QueryClientProvider>
          <BrowserRouter>
            <Switch>
              <div className={container} id="lead-capture-content">
                <Box p={2}>
                  <AnonymousExperimentProvider proId="NoProID" email="" CustomLoader={FormSkeleton}>
                    {children}
                  </AnonymousExperimentProvider>
                </Box>
              </div>
            </Switch>
          </BrowserRouter>
        </QueryClientProvider>
      </HousecallThemeProvider>
    </>
  );
};
